import React from "react"
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { AcceptedRegistrationSources, ConditionOperator, ContactsFiltersConditions } from "@/protocols/ClientCatalogFilterProtocol"

interface SourceOption {
	operator: ConditionOperator
	label: string
}

const sourceOptions: Record<AcceptedRegistrationSources, SourceOption> = {
	integration: {
		operator: "equal",
		label: "Integração"
	},
	manual: {
		operator: "equal",
		label: "Manual"
	},
	webhook: {
		operator: "equal",
		label: "Webhook (Bot)"
	},
	message_blast: {
		operator: "equal",
		label: "Envio em Massa"
	},
	"message-received": {
		operator: "equal",
		label: "Mensagem Recebida"
	},
	file_import: {
		operator: "equal",
		label: "Importação de Arquivos"
	},
	active_campaign_automation_block: {
		operator: "equal",
		label: "Automação (ActiveCampaign)"
	}
}

type ContactRegisteredFromFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_registered_from">
	onChange: (condition: ContactsFiltersConditions<"contact_registered_from">) => void
}
const ContactRegisteredFromFilterCondition: React.FC<ContactRegisteredFromFilterConditionProps> = ({
	condition,
	onChange
}) => {
	const slug = condition.filterData?.registered_from ?? "integration"
	const label = sourceOptions[slug].label

	const handleChange = (newSlug: AcceptedRegistrationSources) => {
		const { operator } = sourceOptions[newSlug]
		onChange({
			type: "contact_registered_from",
			operator,
			filterData: { registered_from: newSlug }
		})
	}

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={12}>
				<FormControl fullWidth variant="outlined" size="small">
					<InputLabel id="contact-registered-from-select-label">
						{label}
					</InputLabel>
					<Select
						labelId="contact-registered-from-select-label"
						label={label}
						value={slug}
						onChange={({ target }) =>
							handleChange(target.value as AcceptedRegistrationSources)
						}
					>
						{Object.entries(sourceOptions).map(([key, opt]) => (
							<MenuItem key={key} value={key}>
								{opt.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	)
}
export default ContactRegisteredFromFilterCondition
